import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MultipleColumnListEntry } from "frontend/contentful/schema/blocks";
import {
  MultipleColumnList,
  MultipleColumnListProps,
} from "design-system/components/blocks/multiple-column-list/multiple-column-list";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { createMediaAssetProps } from "frontend/contentful/components/primitives/media-asset.props";
import { createCtaLinkProps } from "../primitives/cta-link.props";

export const ContentfulMultipleColumnList =
  createContentfulComponent<MultipleColumnListEntry>(
    ({ entry, createEditAttributes }) => {
      const props: MultipleColumnListProps = {
        title: entry.fields.title && (
          <RenderContentfulRichText document={entry.fields.title} />
        ),
        subtitle: (
          <RenderContentfulRichText
            document={entry.fields.subtitle}
            disableParagraphs
          />
        ),
        items: [],
        align: entry.fields.alignment!,
        editAttributes: {
          title: createEditAttributes({ entry, fieldId: "title" }),
          subtitle: createEditAttributes({ entry, fieldId: "subtitle" }),
        },
      };

      const media = entry.fields.media;

      const mediaAssetProps = createMediaAssetProps(media);
      if (mediaAssetProps) props.media = mediaAssetProps;

      entry.fields.links?.forEach((link) => {
        const ctaLinkProps = createCtaLinkProps(link);
        if (ctaLinkProps) props.items?.push(ctaLinkProps);
      });

      return <MultipleColumnList {...props} />;
    },
  );
